import {
    CLEAR_DIAGNOSIS_MATCH,
    GET_CLIENT_DIAGNOSES_SUCCESS,
    GET_DIAGNOSIS_MATCH_SUCCESS,
} from './clientDiagnosis.types';

const initialState = {
    /** Diagnoses of the client whose profile is open, primary first. */
    clientDiagnoses: [],
    /** Last appointment-modal preview: { enforced, status, codes, clientCodes, acceptedCodes }. */
    diagnosisMatch: null,
};

export const clientDiagnosisReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENT_DIAGNOSES_SUCCESS:
            return { ...state, clientDiagnoses: action.payload };
        case GET_DIAGNOSIS_MATCH_SUCCESS:
            return { ...state, diagnosisMatch: action.payload };
        case CLEAR_DIAGNOSIS_MATCH:
            return { ...state, diagnosisMatch: null };
        default:
            return state;
    }
};
